import React from 'react';
import SortDropdown from '../../../components/sort-dropdown/SortDropdown';
import { SearchParams } from '../BrowseListingsPage';

interface SearchResultsHeaderProps {
  totalListings: number;
  searchParams: SearchParams;
  sortOption: string;
  onSort: (option: string) => void;
}

const SearchResultsHeader: React.FC<SearchResultsHeaderProps> = ({
  totalListings,
  searchParams,
  sortOption,
  onSort
}) => {
  const getListingTypeText = () => {
    switch (searchParams.listingIntent) {
      case 'Any':
        return ' Browse';
      case 'rent':
        return ' Rent';
      case 'sale':
        return ' Buy';
      default:
        return ' Share';
    }
  };

  const getLocationText = () => {
    return searchParams.location.length ? searchParams.location : 'Ireland';
  };

  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center my-4 sm:my-6 gap-3 sm:gap-0">
      <p className="text-sm sm:text-base text-gray-700 font-medium">
        {totalListings} {totalListings !== 1 ? 'Properties' : 'Property'} to
        {getListingTypeText()} in {getLocationText()}
      </p>
      <div className="w-full sm:w-auto">
        <SortDropdown
          options={[
            { label: 'Newest Best Match', value: 'bestMatch' },
            { label: 'Price: Low to High', value: 'priceLowToHigh' },
            { label: 'Price: High to Low', value: 'priceHighToLow' }
          ]}
          selectedOption={sortOption}
          onSelect={onSort}
        />
      </div>
    </div>
  );
};

export default SearchResultsHeader;
